import { render, staticRenderFns } from "./Unarchive.vue?vue&type=template&id=1323b90c&"
import script from "./Unarchive.vue?vue&type=script&lang=js&"
export * from "./Unarchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports